import {Link} from "react-router-dom";
import setTitleAndMetaDescription from "../../../components/setTitleAndMetaDescription.tsx";
import Icon from "../../../components/selfcare/Icon.tsx";
import {Job} from "../jobs.ts";
import ScrollToTop from "../../../components/ScrollToTop.tsx";
import setOGImageMeta from "../../../components/setOGImageMeta.tsx";
import IconArrow from "../../../components/icons/IconArrow.tsx";
import Routing from "../../../Routing.ts";
import {formatDate} from "../../../util/formatter.ts";
import {ReactNode} from "react";

export default function JobLayout(props: { job: Job, children: ReactNode }) {
    ScrollToTop()

    setTitleAndMetaDescription(props.job.title + " - Hiper", props.job.description)
    setOGImageMeta(props.job.img_list)

    return (
        <div className={'content'}>
            <section className={'blurb'}>
                <h1 className={'heading heading--montserrat heading--big'}>
                    {props.job.heading}
                    <span className={'heading__title'}>{formatDate(props.job.date)}</span>
                </h1>
                <p>
                    <Link to={Routing.About.Jobs.Index} className="icon-link icon-link-left icon-link-rotate-180 back-link-widget">
                        <Icon component={IconArrow}/> <span className="text">Tilbage</span>
                    </Link>
                </p>
            </section>
            <section className={'job-post'}>
                {props.children}
            </section>
        </div>
    )
}
